export enum ProductType {
    engineeredHardwood = 'engineered_hardwood',
    solidHardwood = 'solid_hardwood',
    laminate = 'laminate',
    lvtVinyl = 'vinyl',
    carpet = 'carpet',
    rug = 'rug',
    ceramic = 'ceramic',
    concrete = 'concrete',
    epoxy = 'epoxy',
    epoxyBase = 'epoxy_base',
    epoxyChips = 'epoxy_chips',
    epoxyCombined = 'epoxy_combined',
    floor = 'floor', // deprecated value for backward compatibility
    model3d = 'model3D',
    wall = 'wall',
    porcelain = 'porcelain',
    lvp = 'lvp',
    naturalStone = 'natural_stone',
    spc = 'spc',
    hybridFloor = 'hybrid_floor',
    bambooFlooring = 'bamboo_flooring',
    wallpaper = 'wallpaper',
    terrazzo = 'terrazzo',
    polishedConcrete = 'polished_concrete',
    timber = 'timber',
    tiles = 'tiles',
    cork = 'cork',
    wpc = 'wpc',
    wallPanel = 'wall_panel',
    countertop = 'countertop',
    paint = 'paint',
    grout = 'grout',
    blind = 'blind',
    pvc = 'pvc',
    parquet = 'parquet',
    rigidVinyl = 'rigid_vinyl',
    woodcore = 'woodcore',
    workshop = 'workshop',
    porcelainTile = 'porcelain_tile',
    porcelanic = 'porcelanic',
    modifiedClayMaterial = 'modified_clay_material',
}
